import { render, staticRenderFns } from "./notificationsButton.vue?vue&type=template&id=f547a926&scoped=true"
import script from "./notificationsButton.vue?vue&type=script&lang=js"
export * from "./notificationsButton.vue?vue&type=script&lang=js"
import style0 from "./notificationsButton.vue?vue&type=style&index=0&id=f547a926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f547a926",
  null
  
)

export default component.exports